import { ErpButtonRaw } from "@/components/erp";
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@/components/providers/ThemeProvider'
import { Monitor, Moon, Sun  } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export const ModeToggle: React.FC = () => {
  const { mode, setMode } = useTheme()
  const { t } = useTranslation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <ErpButtonRaw 
          className="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors focus:outline-none focus:ring-2 focus:ring-ring"
          aria-label={t('Toggle dark mode')}
          title={t('Toggle dark mode')}
        >
          <Moon size={20} className="text-lg dark:hidden" />
          <Sun size={20} className="text-lg hidden dark:block" />
        </ErpButtonRaw>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40 mt-1">
        <DropdownMenuItem 
          onClick={() => setMode('light')}
          className={`cursor-pointer ${mode === 'light' ? 'bg-accent font-medium' : ''}`}
        >
          <Sun size={16} className="mr-2 w-4 text-center opacity-70" /> {t('Light')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setMode('dark')}
          className={`cursor-pointer ${mode === 'dark' ? 'bg-accent font-medium' : ''}`}
        >
          <Moon size={16} className="mr-2 w-4 text-center opacity-70" /> {t('Dark')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setMode('system')}
          className={`cursor-pointer ${mode === 'system' ? 'bg-accent font-medium' : ''}`}
        >
          <Monitor size={16} className="mr-2 w-4 text-center opacity-70" /> {t('System')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
